import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { API_URL } from '../../../settings/local_settings';
import { APIClient } from '../../../utils/APIClient';
import { Spinner } from '../../Spinner';

export default function MarkPaidButton({ liquidationId, onMarked }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [saving, setSaving] = useState(false);

    const handleConfirm = () => {
        setSaving(true);
        new APIClient(API_URL + 'agency/subscription/mark-liquidation-paid/')
            .call('POST', { liquidation_id: liquidationId })
            .then((data) => {
                setSaving(false);
                if (data.status === 'OK') {
                    setIsOpen(false);
                    if (onMarked) onMarked();
                } else {
                    alert(data.error_message || 'Error');
                }
            })
            .catch(() => {
                setSaving(false);
                alert('Error al marcar el pago');
            });
    };

    return (
        <>
            <button
                className="btn -alt"
                onClick={() => setIsOpen(true)}
                style={{
                    fontSize: '0.7em',
                    padding: '0.2em 0.6em',
                    whiteSpace: 'nowrap'
                }}
            >
                {t('agency_subscription.mark_as_paid')}
            </button>
            <Modal isOpen={isOpen} toggle={() => setIsOpen(false)}>
                <ModalHeader toggle={() => setIsOpen(false)}>
                    {t('agency_subscription.mark_as_paid')}
                </ModalHeader>
                <ModalBody>
                    <div className="modal-section" style={{ padding: '0.5em 1em' }}>
                        <p style={{ margin: 0 }}>{t('agency_subscription.confirm_mark_paid')}</p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setIsOpen(false)}>
                        {t('agency_subscription.cancel_action')}
                    </Button>
                    {saving
                        ? <Spinner color="positive small" />
                        : <button className="btn -alt" onClick={handleConfirm}>
                            {t('agency_subscription.confirm_action')}
                        </button>
                    }
                </ModalFooter>
            </Modal>
        </>
    );
}
